import { Fragment } from 'react'
import { useTranslation } from "react-i18next"
import { Container, Row, Col, Button } from 'react-bootstrap'
import { useParams, Link } from 'react-router-dom'

export default function EmailSend() {
    const { t } = useTranslation()
    const {email} = useParams()

    return (
        <Fragment>
            <header className="cabecera d-flex align-items-center px-4">
                <Link to='/'><img src="/images/logotipo-sdplay-cabecera.svg" alt="SDPlay" height={28} /></Link>
            </header>
            <Container fluid className='p-0 m-0'>
                <Row className='p-0 m-0 centro-auth'>
                    <Col md={7} className='d-none d-md-flex align-items-center justify-content-center aside-auth' style={{
                        background: 'linear-gradient(135deg, #0B0C0E 0%, #1A1B1E 100%)',
                    }}>
                        <div style={{maxWidth: 420, color: 'white', padding: 40}}>
                            <h1 style={{color: 'white', fontSize: 40, marginBottom: 16}}>SDPlay</h1>
                            <p style={{fontSize: 16, opacity: 0.7, lineHeight: 1.6}}>{t('forgot.viewemail')}</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} className='d-flex align-items-center justify-content-center p-5'>
                        <div className='login-form-container text-center'>
                            <div className='login-brand text-center'>
                                <img src="/images/logotipo-sdplay-cabecera.svg" alt="SDPlay" />
                            </div>
                            <h1 className='login-title'>{t('forgot.emailsent')}</h1>
                            <p className='login-subtitle'>{email}</p>
                            <Link to={`/${t("url.auth.login")}`} className='btn btn-primary w-100 mt-4'>
                                {t('signin.login')}
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}